// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const GET_DASHBOARD_DATA = 'dashboard/GET_DASHBOARD_DATA';
